import { Model } from '@mode-switch/model';
import { ExportPlan, RecordsQuery } from '@mode-switch/query';
import { Encoding } from '@mode-vegas/vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { buildRecordsQuery } from './table-query';

type ModeRole = FlamingoTypes.ModeRole;

export function buildCsvQuery(
  model: Model<ModeRole>,
  viewName: string,
  encoding: Encoding,
  limit: number,
  offset: number
): ExportPlan<ModeRole> {
  return ExportPlan.make(
    model,
    viewName,
    RecordsQuery.make({
      ...buildRecordsQuery(model, viewName, encoding, limit, offset),
    }),
    {
      type: 'csv',
      headers: true,
    }
  );
}
